import * as React from 'react';

const LocationPin24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 5.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5M9.75 9a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M20 9.8c0 4.971-4.539 9.942-6.779 12.093a1.747 1.747 0 0 1-2.442 0C8.539 19.743 4 14.771 4 9.8 4 4.94 7.582 1 12 1s8 3.94 8 8.8m-1.5 0c0-4.17-3.041-7.3-6.5-7.3S5.5 5.63 5.5 9.8c0 2.055.952 4.243 2.3 6.275 1.33 2.007 2.94 3.701 4.018 4.736.063.06.127.08.182.08a.26.26 0 0 0 .182-.08c1.078-1.035 2.688-2.73 4.019-4.736 1.347-2.031 2.299-4.22 2.299-6.275"
  }
));
LocationPin24.Size = 24;
LocationPin24.Title = "LocationPin";

export { LocationPin24 as default };
